import React from "react";
import { useFormikContext } from "formik";
import { format } from "date-fns";
import DatePickerField from "components/lib/Shared/DatePickerField";

const ManageDateOfChange = ({ field, form }) => {
  const { setFieldValue } = useFormikContext();

  const handleChangeOfParticularsDateValue = (date) => {
    if (!date) {
      setFieldValue(field.name, "");
      return;
    }
    if (isNaN(date.getTime())) {
      console.error("Invalid date:", date);
      return;
    }

    // Format the valid date
    const formattedDate = format(date, "yyyy/MM/dd");
    setFieldValue(field.name, formattedDate);
  };
  return (
    <div className="col-span-6 sm:col-span-3">
      <DatePickerField
        label="Date Of Change Of Particulars"
        onChange={handleChangeOfParticularsDateValue}
        selected={field.value ? new Date(field.value) : null}
        name="changeOfParticularDate"
        form={form}
        placeholderText="Enter date of change"
        errorPath="changeOfParticularDate"
        disabled={false}
      />
    </div>
  );
};

export default ManageDateOfChange;
